import { render } from "./ListLogisticsPartners.vue?vue&type=template&id=48bc73c1"
import script from "./ListLogisticsPartners.vue?vue&type=script&lang=js"
export * from "./ListLogisticsPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__